import { IUserPub } from "@api/auth.int";
import { IGuardSendMailPostApi, IProfileGetApi } from "@api/profile.int";
import { Box, Button, FormControl, FormLabel, Link, ListItem, Text, Textarea, UnorderedList, useBoolean } from "@chakra-ui/react";
import { useDeepAuth, useVVApi } from "components/api";
import { DeepErrorBox } from "components/misc";
import { useVVStore } from "components/store";
import { AFFAIR_DESCRIPTION_MAX, AFFAIR_DESCRIPTION_MIN } from "components/utils";
import { VizvButtonBack, VizvButtonPrimary, VizvCard, VizvCardAction, VizvCardActionStrip, VizvCardContent, VizvCardHeaderPopup, VizvMainCol } from "components/vizvComponents";
import { GuardKindBox, GuardKindContainer } from "features/profile/Profile";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { NavLink, Outlet, useNavigate, useParams } from "react-router";

export interface IGuardContext {
	guard: IUserPub;
}
export const GuardContext = createContext<IGuardContext>({
	guard: undefined as any,
});

export function GuardLayout({ isDetail = false }: { isDetail?: boolean }) {
	const nav = useNavigate();
	const routeParams = useParams();

	const mapNavRoot = useVVStore(state => state.mapNavRoot);
	const isMobile = useVVStore(state => state.isMobile());
	const api = useVVApi();
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState('');
	const [profile, setProfile] = useState<IUserPub>();

	useEffect(() => {
		(async () => {
			if (!routeParams.userKey)
				return;
			try {
				setIsLoading(true);
				setError('');
				const resp = await api.fetch<IProfileGetApi>({
					url: '/auth/profile/:userKey', method: 'GET',
					params: { userKey: routeParams.userKey }
				});
				setProfile(resp.user);
			} catch (ex) {
				setError('' + ex);
			} finally {
				setIsLoading(false);
			}
		})();
	}, [routeParams.userKey]);

	const ctx = useMemo(() => ({
		guard: profile!
	}), [profile]);



	return <GuardContext.Provider value={ctx} >
		<VizvMainCol isDetail={isDetail}>
			<VizvCard onClose={() => nav(mapNavRoot || '/map')}
				minH='40vh' {...!isMobile && { minW: '30em' }}
			>
				<DeepErrorBox error={error} isLoading={isLoading} />
				{profile && <>
					<VizvCardHeaderPopup variant="blue" >
						{profile.userName}
					</VizvCardHeaderPopup>
					<Outlet />
				</>}
			</VizvCard>
		</VizvMainCol>
	</GuardContext.Provider>
}

export function GuardDashboard() {
	const isMobile = useVVStore(state => state.isMobile());
	const auth = useDeepAuth();
	const ctx = useContext(GuardContext);
	const profile = ctx.guard!;

	return <>
		<VizvCardContent display='flex' flexDir='row' gap={3} {...isMobile && { flexDir: 'column' }} >
			{profile.guard
				? <><UnorderedList className=''>
					<ListItem>{profile.guard.locationTitle}</ListItem>
					<ListItem>{profile.guard.message}</ListItem>
					{/*<ListItem>{JSON.stringify(profile.userSummary)}</ListItem>*/}
					{(true || (profile.userSummary && profile.userSummary.jelentettCount)) && <ListItem><Link className="xx2" as={NavLink} to={`/profile-affairs/${profile.userKey}`}>
						Bejelentései
					</Link></ListItem>}
				</UnorderedList>
					<GuardKindContainer display='inline-flex' flexDir='row' width='200px' justifyContent='space-evenly' py={8} mb={1} >
						<GuardKindBox guardKind={profile.guard.kind || '00'} guardName={profile.guard.name} />
					</GuardKindContainer>
				</>
				: <>
					A felhasználónak nincs VízVédő profilja
				</>
			}

		</VizvCardContent>
		<VizvCardActionStrip mt='auto'>
			{auth.userConfirmed ?
				<VizvCardAction
					//to={`/guard/${profile.userKey}/contact`}
					to={`contact`}
				//onClick={e => {e.preventDefault(); alert('Hamarosan...')}}
				>Felveszem a kapcsolatot</VizvCardAction>
				: <VizvCardAction onClick={() => auth.showSignIn('A kapcsolatfelvételhez be kell jelentkezned!')}>Felveszem a kapcsolatot</VizvCardAction>
			}
		</VizvCardActionStrip>
	</>
}


export function GuardContact() {
	const [isLoading, setIsLoading] = useBoolean();
	const [error, setError] = useState('');
	const ctx = useContext(GuardContext);
	const profile = ctx.guard!;
	const nav = useNavigate();
	const [message, setMessage] = useState('');
	const api = useVVApi();

	/*const descriptRef = useRef<HTMLTextAreaElement>(null);
	useEffect(() => {
				window.setTimeout(() => {
					if (descriptRef && descriptRef.current) {
						console.log('itt');
						(descriptRef.current as any).focus();
					}
				}, 300);
	}, []);*/

	const onSubmit = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        setIsLoading.on();
        setError('');
		try {
			const resp = await api.fetch<IGuardSendMailPostApi>({
				url: '/auth/profile/:userKey/send-mail',
				method: 'POST',
				payload: {
					message,
				},
				params: {
					userKey: profile.userKey
				}
			});
			alert('Az üzenetet elküldtük');
			nav('..');
			
		} catch (ex) {
			setError('' + ex);
		} finally {
			setIsLoading.off();
		}
	}


	return <Box p={2} pt={0} mt={-1}>
			Felveheted "{profile.guard?.name || profile.userName}" vízőrrel a kapcsolatot!
			<FormControl>
				<FormLabel>Üzenet</FormLabel>
				<Textarea
					autoFocus
					value={message} onChange={e => setMessage(e.target.value)}
					rows={7} cols={60} />
			</FormControl>

			<VizvCardActionStrip mt='auto'>
				<VizvButtonBack onClick={() => nav('..')} ml={2} >Mégsem</VizvButtonBack>
				<VizvButtonPrimary isDisabled={!message || message.length < AFFAIR_DESCRIPTION_MIN || message.length > AFFAIR_DESCRIPTION_MAX} mr={2}
					isLoading={isLoading} type='submit'
					onClick={onSubmit} >Elküldöm</VizvButtonPrimary>

			</VizvCardActionStrip>
		</Box>

}
